module.exports = __webpack_public_path__ + "img/danckuts-logo-black.0a382434.png";